import { styled } from '@mui/material/styles';
import { Box, Paper } from '@mui/material';

// Auth page container with gradient background
export const AuthPageContainer = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
  paddingTop: '200px',
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    paddingTop: '100px',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// Auth form card container
export const AuthFormCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  maxWidth: 400,
  background: 'rgba(255, 255, 255, 0.95)',
  backdropFilter: 'blur(10px)',
  borderRadius: 8,
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0, 2),
    padding: theme.spacing(2.5),
  },
}));

// Auth form container
export const AuthFormContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  marginTop: theme.spacing(2),
}));

// Auth navigation links container
export const AuthNavContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1.5),
  '& a, & button': {
    fontSize: '0.875rem',
    textDecoration: 'none',
  },
})); 